import { PaymentModalityType } from '@/common/types/companies/companies.type'
import { formatCurrency, truncateText } from '@/common/utils/formatters'
import { GovernmentAllocationData } from '@/features/governmentAllocations/types/governmentAllocation.type'
import { useId } from 'react'
import { Tooltip } from 'react-tooltip'

type GovernmentAllocationDetailsProps = {
  governmentAllocation: GovernmentAllocationData
  paymentModality?: PaymentModalityType
}

export const GovernmentAllocationDetails = ({
  governmentAllocation,
  paymentModality,
}: GovernmentAllocationDetailsProps) => {
  const tooltipId = useId()

  return (
    <div className="flex gap-4 items-end">
      <div className="flex flex-col gap-2">
        <div className='grow flex items-center justify-between gap-2'>
          <p className="text-xs font-bold leading-3 cursor-default" data-tooltip-id={`${tooltipId}_display_name_tooltip`}>
            {governmentAllocation.main_entry.office_number} - {truncateText(governmentAllocation.branch_display_name, 30)}
          </p>

          <Tooltip id={`${tooltipId}_display_name_tooltip`} className="z-50">
            {governmentAllocation.branch_display_name}
          </Tooltip>
        </div>

        <div className="flex flex-row gap-2">
          <div className="flex flex-col gap-2">
            <div className='flex flex-col gap-2'>
              <p className="text-[10px] font-light italic leading-3">
                {paymentModality === 'pre_paid' ? 'Empenhado' : 'Cotado'}
              </p>
              <p className="text-xs font-bold leading-3">{formatCurrency(Number(governmentAllocation.total_value))}</p>
            </div>

            <div className="text-yellow-400 flex flex-col gap-2">
              <p className="text-[10px] font-light italic leading-3">Consumido</p>
              <p className="text-xs font-bold leading-3">{formatCurrency(Number(governmentAllocation.consumed_total))}</p>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <div className='flex flex-col gap-2'>
              <p className="text-[10px] font-light italic leading-3">Aprovado</p>
              <p className="text-xs font-bold leading-3">{formatCurrency(Number(governmentAllocation.approved_value))}</p>
            </div>

            <div className="text-valid flex flex-col gap-2">
              <p className="text-[10px] font-light italic leading-3">Disponível</p>
              <p className="text-xs font-bold leading-3">{formatCurrency(Number(governmentAllocation.remaining_total))}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
